var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { title: "" + _vm.title, "hide-footer": "", centered: "" },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "form",
        {
          attrs: {
            "data-vv-scope": "folder-form",
            autocomplete: "autocomplete_off_name"
          },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|max:255",
                      expression: "'required|max:255'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    name: "name",
                    "data-cy": "folder-name",
                    label: "Nombre para carpeta",
                    autocomplete: "autocomplete_off_name",
                    "data-vv-as": "Nombre para carpeta",
                    "val-icon-danger": "error_outline",
                    danger: _vm.errors.has("folder-form.name"),
                    "danger-text": _vm.errors.first("folder-form.name"),
                    "val-icon-success": "check_circle",
                    success:
                      !_vm.errors.has("folder-form.name") &&
                      _vm.formValues.name.length > 0
                  },
                  model: {
                    value: _vm.formValues.name,
                    callback: function($$v) {
                      _vm.$set(_vm.formValues, "name", $$v)
                    },
                    expression: "formValues.name"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "m-top-20 d-flex justify-end" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mt-5 ml-3",
                  attrs: {
                    color: "primary",
                    type: "border",
                    "data-cy": "save"
                  },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(" " + _vm._s(_vm.buttonLabel) + " "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "spinner-border spinner-border-sm text-white"
                  })
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }